// @flow
import {compose} from 'recompose';
import {connect} from 'react-redux';

import TransportConnectionsList from './TransportConnectionsList';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(TransportConnectionsList);
